'use client';

import { getFragmentData } from '@/__generated__';
import { ENTRY_BASE_FRAGMENT } from '@/gql/fragments/entries.gql';
import { FAQ_INDEX_CARD_FRAGMENT } from '@/gql/fragments/entryCards.gql';
import { withFragment } from '@liquorice/gql-utils';
import Breadcrumbs from '../Breadcrumbs';
import PageHeaderRoot from './PageHeaderRoot';
import PageTitle from './PageTitle';

const PageHeaderFaqIndex = withFragment(FAQ_INDEX_CARD_FRAGMENT, (data) => {
  if (!data) return null;

  const base = getFragmentData(ENTRY_BASE_FRAGMENT, data);

  return (
    <PageHeaderRoot variant="index">
      <Breadcrumbs data={base} CtaButtonProps={{ color: 'black' }} cx={{ mB: 'xs' }} />
      <PageTitle>{data.entryTitle}</PageTitle>
    </PageHeaderRoot>
  );
});

export default PageHeaderFaqIndex;
